import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { QuickMitsumoriQrInfo } from "@/model/QuickMitsumoriQrInfo";

const initialState: QuickMitsumoriQrInfo = {
    id: null,
    sknQuickMitsumoriId: null,
    isHasImg: null,
    base64QrImage: null,
    qrUrl: null
};

const actions: ActionTree<QuickMitsumoriQrInfo, any> = {
  setState(
    { commit }: ActionContext<QuickMitsumoriQrInfo, any>,
    payload: QuickMitsumoriQrInfo
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<QuickMitsumoriQrInfo, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: QuickMitsumoriQrInfo, payload: QuickMitsumoriQrInfo) {
    Object.assign(state, payload);
  },
  clearState(state: QuickMitsumoriQrInfo) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<QuickMitsumoriQrInfo, any> = {
  currentState(state: QuickMitsumoriQrInfo): any {
    return state;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
